export class RequestExecutorError extends Error {
    static tryParseJSON(body) {
        try {
            return JSON.parse(body);
        }
        catch (e) {
            return null;
        }
    }
    static serverError(endpoint, status, bodyText) {
        var _a, _b;
        const parsedBody = this.tryParseJSON(bodyText);
        return new RequestExecutorError("ServerError", `Endpoint ${endpoint} returned ${status}\n${bodyText}`, (_a = parsedBody === null || parsedBody === void 0 ? void 0 : parsedBody.errorCode) !== null && _a !== void 0 ? _a : null, (_b = parsedBody === null || parsedBody === void 0 ? void 0 : parsedBody.type) !== null && _b !== void 0 ? _b : null, parsedBody !== null && parsedBody !== void 0 ? parsedBody : null);
    }
    static responseParsingError(endpoint, cause) {
        return new RequestExecutorError("ResponseParsingError", `Endpoint ${endpoint} returned incompatible JSON`, undefined, undefined, cause);
    }
    getDisplayMessage() {
        if (this.type === "ServerError" &&
            this.cause &&
            typeof this.cause === "object" &&
            "message" in this.cause) {
            return this.cause.message || this.message;
        }
        return this.message;
    }
    constructor(type, message, errorCode, serverErrorType, cause) {
        super(`${type}: ${message}`, { cause });
        this.type = type;
        this.errorCode = errorCode;
        this.serverErrorType = serverErrorType;
    }
}
